import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';
import { canUseWorkflow } from '~/permissions/canUseWorkflow';
import { User } from '~/types/User';

import { RoutePathType } from '../enums';
import { Component, RouteResolver } from '../types';

/**
 * Creates resolvers for routes shared between legacy CLM workflows and CLM
 * Evolution workflows (e.g. the Word for the web page):
 * - Resolves to the component when the user has the legacy Workflow feature
 *   flag OR the CLM Evolution flag is enabled.
 * - Redirects to RoutePathType.Home otherwise.
 *
 * This intentionally mirrors createWorkflowResolvers but widens access to CLM
 * Evolution, so the legacy-only workflow routes are left unaffected.
 */
export const createWorkflowOrClmEvolutionResolvers = (
  component: Component,
): RouteResolver[] => {
  return [
    {
      permission: (user: User) =>
        getFlag(FlagType.CLMEvolutionPhase1) || canUseWorkflow(user),
      component,
    },
    {
      redirectPath: RoutePathType.Home,
    },
  ];
};
